<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <app-drop-down
                  type="status"
                  [settings]="dropdownSettings"
                  [list]="dropdownListStatus"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="selectedStatus"
                ></app-drop-down>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                User Email
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="userEmail"
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Published Date
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'publishedDate'"
                  [DropDownOptions]="publishedDatesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Vertical
              </td>
              <td>
                <app-drop-down
                  type="vertical"
                  [settings]="dropdownSettings"
                  [list]="dropdownListVertical"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="selectedVertical"
                ></app-drop-down>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Product Type
              </td>
              <td>
                <app-drop-down
                  type="productType"
                  [settings]="dropdownSettings"
                  [list]="dropdownListProductType"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="selectedProductType"
                ></app-drop-down>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Product ID
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="productId"
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Portfolio Director
              </td>
              <td>
                <app-drop-down
                  type="portfolioDirector"
                  [settings]="dropdownSettings"
                  [list]="dropdownListPortfolioDirector"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="selectedPortfolioDirector"
                ></app-drop-down>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Book Type
              </td>
              <td>
                <app-drop-down
                  type="bookType"
                  [settings]="dropdownSettings"
                  [list]="dropdownListBookType"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="selectedBookType"
                ></app-drop-down>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Date Changed
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'changeDate'"
                  [DropDownOptions]="datesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [selectedOption]="selectedChangeDate"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Project Manager
              </td>
              <td>
                <app-drop-down
                  type="projectManager"
                  [settings]="dropdownSettings"
                  [list]="dropdownListProjectManager"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="selectedProjectManager"
                ></app-drop-down>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container mt-3">
  <div class="card">
    <div class="card-body" style="font-size: 12px;">
      <p>
        To view all data, please remove name from User Id field and click
        search.
        <br />
        After clicking reset, It will reset the filter and data
      </p>
    </div>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Product ID</th>
          <th scope="col">Date Changed</th>
          <th scope="col">Working Title</th>
          <th scope="col">Program Manager</th>
          <th scope="col">Project Manager</th>
          <th scope="col">Portfolio Director</th>
          <th scope="col">Vertical</th>
          <th scope="col">Current OSD</th>
          <th scope="col">Change By</th>
          <th scope="col">Before Change</th>
          <th scope="col">After Change</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.part_number}}</td>
          <td>{{product.date_created}}</td>
          <td>{{product.name}}</td>
          <td>{{product.program_manager}}</td>
          <td>{{product.project_manager}}</td>
          <td>{{product.portfolio_director}}</td>
          <td>{{product.portfolio}}</td>
          <td>{{product.current_osd}}</td>
          <td>{{product.changed_by}}</td>
          <td>{{product.before_value_string}}</td>
          <td>{{product.after_value_string}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
